import React from "react";
import { Empty, Skeleton } from "antd";

import { ChatMessage } from "../ChatMessage";
import { useMessageList } from "./useMessageList";

import {
  MessageListContainer,
  Messages
} from './styles';

export const MessageList = ({
  chatContext,
  messages,
  handleMarkTicketAsRead,
  adminUsers,
}) => {
  const {
    caseDetails,
    messageContainerRef,
    createChatMessageProps,
  } = useMessageList({
    chatContext,
    messages,
    handleMarkTicketAsRead,
  });

  return (
    <Skeleton
      loading={!caseDetails}
      paragraph={{ rows: 50 }}
    >
      <MessageListContainer>
        {
          messages.list?.length === 0 && (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No messages yet"
              style={{ alignSelf: 'center', color: '#999999' }}
            />
          )
        }
        <Messages ref={messageContainerRef}>
          {
            messages.list?.map(messageObj => {
              const chatMessageProps = createChatMessageProps(messageObj);
              return (
                <ChatMessage 
                  key={messageObj._id} 
                  {...chatMessageProps} 
                  adminUsers={adminUsers}
                />
              );
            })
          }
        </Messages>
      </MessageListContainer>
    </Skeleton>
  );
};
